// Import Dependencies
import { useCallback, useState } from "react";
import PropTypes from "prop-types";

import { AuthModalContext } from "./context";
import { AuthModal } from "components/shared/AuthModal";


export function AuthModalProvider({ children }) {
  const [state, setState] = useState({
    isOpen: false,
    label: "Learning PSIR",
    onSuccess: null,
  });

  const openAuthModal = useCallback(({ label, onSuccess } = {}) => {
    setState({
      isOpen: true,
      label: label || "Learning PSIR",
      onSuccess: onSuccess || null,
    });
  }, []);

  const closeAuthModal = useCallback(() => {
    setState((s) => ({ ...s, isOpen: false }));
  }, []);

  return (
    <AuthModalContext
      value={{
        ...state,
        openAuthModal,
        closeAuthModal,
      }}
    >
      {children}
      <AuthModal />
    </AuthModalContext>
  );
}

AuthModalProvider.propTypes = {
  children: PropTypes.node,
};